import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { AppConfig } from '../../utils/app-config.service';
import { MyHttpClient } from './my-http-client';

import { environment } from '../../../../environments/environment';

@Injectable()
export class LegalApiClient {
    constructor(private http: MyHttpClient) {}

    getLegalDisclaimer(): Observable<string> {
        return of(AppConfig.settings.services.base + environment.services.paths.get_legal_conditions_disclaimer).pipe(
            switchMap((url) => {
                return this.http.post(url, null).pipe(
                    map((resp: any) => {
                        if (!resp || !resp.Disclaimer) {
                            throw new Error('error.general');
                        } else {
                            return resp.Disclaimer;
                        }
                    })
                );
            })
        );
    }
}
